module.exports = __webpack_public_path__ + "public/files/img/banner.70bbe18d.png";